var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcCremaGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aeb0b0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.8,48.79H19.2a4.64,4.64,0,0,1-3.92-2.17l-1.87-3a20.19,20.19,0,0,1-3.07-10.69V31.45a1.16,1.16,0,0,1,1.16-1.16h37a1.16,1.16,0,0,1,1.16,1.16v1.48a20.22,20.22,0,0,1-3.07,10.69l-1.87,3a4.64,4.64,0,0,1-3.92,2.17ZM12.32,28c-1.67-6.16.76-11.74,7.16-16.54a1.15,1.15,0,0,1,1.75.47c2.07,4.83,5.7,6.31,11.32,4.56,9-2.82,16.39,3.55,15,11.51Zm7.12-3.49A6.32,6.32,0,0,1,21,20.08a1.16,1.16,0,1,0-1.72-1.55,8.68,8.68,0,0,0-2.19,6,1.16,1.16,0,0,0,2.32,0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcCremaGray);
export default __webpack_public_path__ + "static/media/DC__crema_gray.e01da9e18c3a43a875c99e112f1a80d0.svg";
export { ForwardRef as ReactComponent };